
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/generated-templates/ai-generated-page",
      function () {
        return require("private-next-pages/generated-templates/ai-generated-page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/generated-templates/ai-generated-page"])
      });
    }
  